<script lang="ts">
	import dayjs from 'dayjs';
	import relativeTime from 'dayjs/plugin/relativeTime.js';

	interface Props {
		title: string;
		slug: string;
		thumbnail: string;
		excerpt?: string | undefined;
		alt?: string;
		themes?: string[];
		dateFormat?: 'relative' | 'absolute';
		publishedAt?: string | undefined;
		dataType?: string | undefined;
		dataContent?: string | undefined;
	}

	let {
		title,
		slug,
		thumbnail,
		excerpt = undefined,
		alt = 'thumbnail',
		themes = [],
		dateFormat = 'absolute',
		publishedAt = undefined,
		dataType = undefined,
		dataContent = undefined
	}: Props = $props();

	dayjs.extend(relativeTime);
</script>

<article class="group @container py-4">
	<p class="text-gray-mid mb-2">
		{#if themes.length}
			<span class="small-bold uppercase">{themes.join(', ')}</span>
			<span class="small-bold">&nbsp;•&nbsp;</span>
		{/if}
		{#if publishedAt}
			<span class="small-regular">
				{#if dateFormat === 'absolute'}
					{dayjs(publishedAt).format('DD MMM YYYY')}
				{:else}
					{dayjs(publishedAt).fromNow()}
				{/if}
			</span>
		{/if}
	</p>
	<div class="flex gap-4">
		<div class="basis-full">
			<a
				href="/{slug}"
				data-type={dataType}
				data-content={dataContent}
				class="hover:text-green-primary group-has-[a:hover]:text-green-primary"
			>
				<header class="card-bold mb-1 line-clamp-3">
					{title}
				</header>
				{#if excerpt}
					<p class="card-regular text-gray-dark line-clamp-2">
						{excerpt}
					</p>
				{/if}
			</a>
		</div>
		<a class="block shrink-0" href="/{slug}" data-type={dataType} data-content={dataContent}>
			<img
				class="aspect-16/9 w-28 rounded-lg object-cover @lg:w-32"
				src={thumbnail}
				alt={alt ?? 'thumbnail'}
			/>
		</a>
	</div>
</article>
